<template>
  <div>
    <el-tabs class="con-wrap" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label name></el-tab-pane>
      <el-tab-pane label="个人统计" name="first">
        <user-record></user-record>
      </el-tab-pane>
      <el-tab-pane label="部门统计" name="second">
        <dept-record></dept-record>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import UserRecord from "./components/UserRecord.vue"
import DeptRecord from "./components/DeptRecord.vue"
export default {
  components: {
    UserRecord,
    DeptRecord,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      limit:12,
      currentPage:0,
      activeName: "first",
    }
  },
  methods: {
    load(){
      // this.currentPage += 1
      console.log(99)
      // this.getPowerData()
    },
   
    handleClick(tab, event) {
      console.log(tab, event)
    }
  },
}
</script>
<style lang="scss" scoped>
.con-wrap /deep/ {
  height: calc(100% - 40px);
  overflow: auto;
  .el-tabs__header {
    background: #fff;
    margin-bottom: 20px;
  }
  #tab-0 {
    padding: 0;
    height: 0;
  }
  .el-tabs__content {
    background: #fff;
    height: calc(100% - 60px);
    overflow-y: auto;
  }
}
.detail{
  width:100%;
  height:100%;
  padding:20px;
  box-sizing: border-box;
  .userDetail{
    margin:20px 0!important;
    width:calc(100%-40px);
    height:136px;
    background: #fff;
    padding:20px;
    box-sizing: border-box;
    font-size:14px;
    .userTitle{
      padding:0 40px;
      height:48px;
      line-height: 48px;
      background: #F4F4F4;
    }
    .userData{
      padding:0 40px;
      height:48px;
      line-height: 48px;
      background: #Fff;
    }
  }
  .detailTable{
    width:100%;
    height:calc(100% - 210px);
    background: #fff;
    padding:20px;
    box-sizing: border-box;
  }
}
</style>
